/**
 * @author Jackson Bingham <jackson@onlineimage.com>
 */

import {defineStore} from "pinia";
import {ref, watch} from "vue";
import {useStorage} from "@vueuse/core";
import User from "../models/User.ts";

export const useUser = defineStore("userStore", () => {
    // Local raw storage (JSON object) used for persistence.
    const rawUser = useStorage<any>("genauth_user", null);

    // Reactive class-based instance for the app to use
    const user = ref<User | null>(rawUser.value ? User.fromJson(rawUser.value) : null);

    // Keep rawUser in sync with user for persistence
    watch(user, (newVal) => {
        rawUser.value = newVal ? newVal.toJSON() : null;
    }, { deep: true });

    const get = (): User => {
        return user.value as User;
    };

    const set = (u: User): void => {
        user.value = u;
    };

    const clear = (): void => {
        user.value = null;
    };

    return {
        user,
        get,
        set,
        clear,
    };
});
